import { IGamesCategory } from '../../types';
import { GamesStorageType } from '../types';

export const selectCategories = ({
  ids,
  data
}: {
  ids: string[];
  data: Record<string, IGamesCategory>;
}) => ids.map((id) => data[id]);

export const mapAndFilterGameLaunchIds = (
  launchIds: (string | number)[],
  launchIdToGameId: Record<number | string, string>,
  feedGamesIds: string[]
) => {
  return launchIds
    .map((gameLaunchId) => launchIdToGameId[gameLaunchId])
    .filter((gameId) => gameId && feedGamesIds.includes(gameId));
};

export const selectLaunchIdToGameId = (state: GamesStorageType) =>
  state.games.launchIdToGameId;
export const selectFeedByFeedName = (
  state: GamesStorageType,
  feedName: string
) => state.feeds?.[feedName];
